<template>
  <el-dialog
    v-loading="loading"
    class="jx-pg-content-dialog o-dialog o-dialog--sm o-dialog--md-90 o-dialog--lg-90 o-dialog--xl-90 o-dialog-h--85"
    title="检查内容"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      class="c-form"
      :inline="true"
      label-width="120px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估专业"
          >
            <span class="c-form__read">{{ detail.pglxMc || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估子项"
          >
            <span class="c-form__read">{{ detail.dxMc || '-' }} / {{ detail.zxMc || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="检查内容"
          >
            <span class="c-form__read">{{ detail.jcnr || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="标准要求"
          >
            <span class="c-form__read">{{ detail.bzyq || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="检查依据"
          >
            <span class="c-form__read">{{ detail.jcyj || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="c-form"
      :inline="true"
      label-position="right"
      label-width="120px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评定结果"
            prop="jgdm"
          >
            <el-select
              v-model="form.jgdm"
              :disabled="readOnly"
              @change="resultChanged"
            >
              <el-option
                label="符合"
                value="FH"
              />
              <el-option
                label="不符合"
                value="BFH"
              />
              <el-option
                label="不适用"
                value="BSY"
              />
              <el-option
                label="无法判定"
                value="WFPD"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑物/对象"
          >
            <el-select
              v-model="form.jzwId"
              :disabled="readOnly"
              clearable
            >
              <el-option
                v-for="item in buildings"
                :key="item.jzwId"
                :label="item.jzwmc"
                :value="item.jzwId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="具体位置"
          >
            <el-input
              v-model.trim="form.jcwz"
              :disabled="readOnly"
              maxlength="500"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.jgdm"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="检查情况（选填）"
          >
            <el-input
              v-model.trim="form.jcqk"
              :disabled="readOnly"
              type="textarea"
              :rows="4"
              maxlength="4000"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <template v-if="form.jgdm === 'BFH'">
        <el-divider content-position="left">
          关联问题
        </el-divider>
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="有效问题"
            >
              <el-select
                v-model="form.wtIds"
                :disabled="readOnly"
                multiple
                filterable
                class="jx-pg-content__full"
                placeholder="可先保存不符合结果，后续再关联问题"
              >
                <el-option
                  v-for="item in issueOptions"
                  :key="item.wtId"
                  :label="`${item.wtbh} ${item.wtms}`"
                  :value="item.wtId"
                />
              </el-select>
              <k-button
                v-if="!readOnly"
                btn-text="新增问题"
                :auth-type="true"
                type="primary"
                plain
                class="jx-pg-content__issue-button"
                @click="issueDialogVisible = true"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <el-divider content-position="left">
        现场图片
      </el-divider>
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="现场图片"
          >
            <attachment-editor
              v-model="form.attachments"
              :types="attachmentTypes"
              :read-only="readOnly"
              business-type="jxxfpgjcjl"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="!readOnly"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="save"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="dialogVisible = false"
      />
    </div>

    <issue-dialog
      v-if="issueDialogVisible"
      :visible="issueDialogVisible"
      :xm-id="xmId"
      @close="issueDialogVisible = false"
      @saved="issueSaved"
    />
  </el-dialog>
</template>

<script>
import AttachmentEditor from './AttachmentEditor.vue';
import IssueDialog from './IssueDialog.vue';
import { pgIssueService } from './issue.service';
import { pgExecutionService } from './execution.service';

export default {
  name: 'JxxfPgContentDialog',
  components: { AttachmentEditor, IssueDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    xmId: {
      type: String,
      required: true
    },
    xmnrId: {
      type: String,
      required: true
    },
    buildings: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: this.visible,
      issueDialogVisible: false,
      detail: {},
      issueOptions: [],
      form: {
        jgdm: '',
        jcqk: '',
        jzwId: '',
        jcwz: '',
        wtIds: [],
        attachments: [],
        lockVersion: null
      },
      attachmentTypes: [
        { value: 'ZJ', label: '现场图片' },
        { value: 'QT', label: '其他资料' }
      ],
      rules: {
        jgdm: [{ required: true, message: '请选择评定结果', trigger: 'change' }]
      }
    };
  },
  methods: {
    load () {
      this.loading = true;
      Promise.all([
        pgExecutionService.detail(this.xmnrId),
        pgIssueService.page({ xmId: this.xmId, pageNo: 1, pageSize: 1000 })
      ]).then(([detailRsp, issueRsp]) => {
        this.detail = detailRsp.data || {};
        this.form = Object.assign({}, this.form, {
          jgdm: this.detail.jgdm || '',
          jcqk: this.detail.jcqk || '',
          jzwId: this.detail.jzwId || '',
          jcwz: this.detail.jcwz || '',
          wtIds: this.detail.wtIds || [],
          attachments: this.detail.attachments || [],
          lockVersion: this.detail.lockVersion
        });
        this.issueOptions = (issueRsp.data || {}).rows || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    loadIssues () {
      return pgIssueService.page({
        xmId: this.xmId,
        pageNo: 1,
        pageSize: 1000
      }).then(rsp => {
        this.issueOptions = (rsp.data || {}).rows || [];
      });
    },
    resultChanged () {
      if (this.form.jgdm !== 'BFH') this.form.wtIds = [];
    },
    save () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading = true;
        pgExecutionService.save(this.xmnrId, this.form).then(() => {
          this.$message.success('评定结果保存成功');
          this.$emit('saved');
          this.dialogVisible = false;
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    issueSaved (wtId) {
      this.issueDialogVisible = false;
      if (wtId && !this.form.wtIds.includes(wtId)) {
        this.form.wtIds.push(wtId);
      }
      this.loadIssues();
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value;
      if (value) this.load();
    }
  },
  created () {
    if (this.visible) this.load();
  }
};
</script>

<style scoped lang="scss">
.jx-pg-content__full,
.el-select {
  width: 100%;
}

.jx-pg-content__issue-button {
  margin-top: 8px;
}

.jx-pg-content-dialog ::v-deep .el-dialog__body {
  overflow-x: hidden;
}

.jx-pg-content-dialog ::v-deep .el-input,
.jx-pg-content-dialog ::v-deep .el-textarea {
  width: 100%;
}

.jx-pg-content-dialog ::v-deep .jx-pg-attachments__row {
  flex-wrap: wrap;
}

.jx-pg-content-dialog ::v-deep .jx-pg-attachments__name {
  min-width: 0;
}
</style>
